// Strings of the correction pass of 2026-10-27 (POS payments, direct printing, adding customers in place, invoice
// posting and correction, item movement, shift close and print, report printing, product import and the financial
// reports). Arabic marked "new" needs review by an Arabic copy editor.
export const CORRECTION_STRINGS: Record<"en" | "ar", Record<string, string>> = {
  en: {
    impF_code: "Item code",
    impF_nameAr: "Arabic name",
    impF_nameEn: "English name",
    impF_category: "Category",
    impF_itemKind: "Item kind",
    impF_taxType: "Tax type",
    impF_baseUnit: "Base unit",
    impF_baseBarcode: "Base unit barcode",
    impF_priceRetail: "Retail price",
    impF_priceWholesale: "Wholesale price",
    impF_priceHalf: "Half-wholesale price",
    impF_unit2: "Second unit",
    impF_unit2Pieces: "Second unit pieces",
    impF_unit2Barcode: "Second unit barcode",
    impF_unit2PriceRetail: "Second unit retail price",
    impF_unit2PriceWholesale: "Second unit wholesale price",
    impF_unit2PriceHalf: "Second unit half-wholesale price",
    impF_minQty: "Minimum quantity",
    impF_discount: "Discount %",
    impF_priceIncludeTax: "Price includes tax (yes/no)",
    impF_quickList: "Quick list (yes/no)",
    impF_descriptionAr: "Arabic description",
    impF_descriptionEn: "English description",
    impTitle: "Import products",
    impSub: "Add many products at once from an Excel (.xlsx) or CSV file.",
    impSheet: "Products",
    impTemplate: "Download the template",
    impTemplateHint: "One row per product: the base unit and, optionally, a second unit. Category, kind, tax type and units are written by their name as in Delta. Several barcodes go in one cell separated by |. The code and barcode columns of the Excel template are formatted as text, so leading zeros stay.",
    impTemplateXlsx: "Excel template (.xlsx)",
    impTemplateCsv: "CSV template",
    impChoose: "Choose the file",
    impFileInfo: "{name}: {n} data rows.",
    impReadFailed: "The file could not be read. Use the template, saved as .xlsx or CSV (UTF-8).",
    impMapping: "Match the columns",
    impField: "Field",
    impColumn: "Column in the file",
    impNotInFile: "Not in the file",
    impTextCol: "kept as text",
    impNoStock: "Importing creates products only: no stock quantity, cost or account balance is created. Opening stock is entered with a beginning inventory document.",
    impMissing: "Match the required fields: {x}.",
    impPreview: "Check and preview",
    impPreviewTitle: "Preview",
    impRows: "Rows in the file",
    impValid: "Rows ready to import",
    impCreated: "Products created",
    impErrorRows: "Rows with errors",
    impRow: "Row",
    impProblem: "Problem",
    impProblems: "Problems",
    impErrorFile: "Download the error file",
    impConfirm: "Import {n} products",
    impSkipNote: "Rows with errors are not imported. Correct them in the file and import it again: rows already imported are reported as existing, never changed.",
    impDone: "Import finished",
    impReplayed: "This import was already done: nothing was created again.",
    impPrevious: "This file was imported before ({at}, by {by}, {n} products).",
    impRules: "Existing products are never changed: a code or barcode already in use is reported on its row. Only users with the Add item permission can import, into their own organization.",
    impE_required: "Required",
    impE_not_found: "Not found in Delta",
    impE_invalid: "Not a number (write it like 1234.50)",
    impE_duplicate_in_file: "Repeated in the file (first in row {row})",
    impE_exists: "Already used by an existing product",
    impE_yes_no: "Write yes or no",
    impE_barcode_scientific: "Barcode in scientific notation: Excel turned it into a number",
    impE_stored_as_number: "Stored as a number in Excel: leading zeros may be lost. Format the column as text and type it again",
    printTestRetry: "Retry test print",
    srClosePrint: "Close & print report",
    srPrintAgain: "Print again",
    srPrintAgainAsk: "The printer did not confirm the last print. Check the paper first: print another report?",
    srPrintAgainYes: "Yes, print again",
    itemMovement: "Item movement",
    imOpening: "Opening balance (all earlier movements)",
    imClosing: "Closing balance",
    imType: "Movement",
    imIn: "In",
    imOut: "Out",
    imBalance: "Balance",
    imType_opening: "Opening stock",
    imType_purchase: "Purchase",
    imType_sale: "Sale",
    imType_sale_return: "Sales return",
    imType_purchase_return: "Purchase return",
    imType_transfer: "Transfer",
    imType_damaged: "Damaged stock",
    imType_count: "Stock count adjustment",
    imType_compromise: "Settlement adjustment",
    imReconciled: "Reconciled: all movements add up to the stock held now ({x}).",
    imNotReconciled: "Not reconciled: the movements add up to {l} but {h} is held now (difference {d}).",
    imDraftsNote: "Only posted documents move stock: drafts are not listed. A reversed document is shown with its reversal. Quantities are in the item's base unit.",
    paySplit: "Split",
    payRest: "Rest",
    payFillRest: "Put what is still unpaid on this method",
    payCardNote: "Card and transfer payments (mada and others) are recorded by method only: Delta is not connected to the card terminal. Take the payment on the terminal first.",
    invPostInvoice: "Post invoice",
    invSaveDraftHint: "Saves a draft: editable, with no effect on stock, money, the ledger or reports.",
    invPostHint: "Saves and posts: stock, payments and the journal entry are recorded together, once. A posted invoice is no longer edited; it is corrected.",
    invCorrect: "Correct",
    invCorrects: "Corrects",
    invCorrectedBy: "Corrected by",
    invReplacementNote: "This draft corrects {x}. Nothing has changed yet: {x} stays posted until you post this draft and confirm. Posting reverses {x} and posts this invoice in one step. Deleting this draft leaves {x} as it is.",
    invCorrectedNote: "This invoice was corrected: it is reversed and replaced by {x}. It stays on record with its audit trail and its payments.",
    invCorrectionPrepared: "A correction of {x} is prepared as a draft. Nothing has changed yet: {x} is reversed only when that draft is posted.",
    invCorrectionOf: "Correction of {x}",
    invCorrectedOk: "Replacement draft prepared. {x} is unchanged until you post the replacement.",
    invCorrectSub: "A replacement draft is prepared with the same lines, dated below. Nothing changes now. Posting the replacement (after you confirm) reverses this invoice on that date and posts the replacement in one step. The payments already made are kept and used by the replacement: never refunded, never taken again. Deleting the draft cancels the correction.",
    invCorrectGo: "Prepare replacement",
    invCarriedHint: "{p} paid on {x} is kept: this invoice uses {c} of it. Add a payment only for anything more.",
    invCarriedShow: "{c} of the payments made on {x} (kept, not refunded or taken again).",
    invConfirmTitle: "Post the correction of {x}",
    invConfirmSub: "In one step: {x} is reversed on {d} (its stock and ledger entry come back; its payments are kept), and this invoice is posted. If anything fails, nothing changes.",
    invConfirmOriginal: "{x} (reversed)",
    invConfirmReplacement: "This invoice",
    invConfirmCarried: "Payments of {x} used",
    invConfirmNew: "New payments",
    invConfirmOnAccount: "Left on the account",
    invConfirmCredit: "Credit left on the account (paid on the original, more than this total)",
    invConfirmGo: "Reverse and post",
    fieldCorrectionNeedsParty: "The original was paid: choose the customer or supplier the payment is held for.",
    posCompleteSale: "Complete sale",
    posCompleteNote: "Complete sale posts the sale with these payments in this shift, in one step. Nothing is recorded before it. To keep the cart without recording anything, close this and save it as a draft.",
    posSaveDraftHint: "Keeps the cart as a draft: no payment, stock, cash or shift figure is recorded until you complete it.",
    posDraftSaved: "Draft saved ({total}). Nothing is recorded until it is completed.",
    posDrafts: "Drafts",
    posDraftsNote: "Saved carts. A draft records nothing: no payment, stock, cash, ledger or shift figure. Resume one to complete it.",
    posNoDrafts: "No saved drafts.",
    posDraftResume: "Resume",
    posDraftEditing: "This cart continues a saved draft. Complete sale posts it; Save draft keeps it.",
    posDraftCartBusy: "Save or clear the current cart before resuming a draft.",
    // ---------- report printing (item 7)
    rpPrint: "Print",
    rpPrintBrowser: "Print or save as PDF",
    rpPrintOn: "Print on {printer}",
    rpPrintPage: "Page {i} of {n}",
    rpPrintContinued: "continued",
    rpPrintBy: "Printed by {u} on {d}",
    rpPrintNoRows: "No rows for these filters.",
    rpPrintSent: "Sent to {printer}.",
    rpPrintFailed: "Not printed on this PC's A4 printer: {x}. Nothing was printed; you can try again or use Print or save as PDF.",
    rpPrintUnknown: "The printer did not confirm the report ({x}). Check the printer before printing again, so it is not printed twice.",
    rpPrinting: "Sending to the printer…",
    rpPeriod: "Period",
    rpBranch: "Branch",
    rpAllBranches: "All branches",
    // ---------- financial reports (item 9)
    cashFlow: "Cash flow statement",
    cashFlowIndicators: "Cash flow indicators",
    cashFlowMappings: "Cash flow classification",
    cfOpening: "Cash and cash equivalents at the start",
    cfClosing: "Cash and cash equivalents at the end",
    cfNet: "Net change in cash",
    cfInflow: "Inflow",
    cfOutflow: "Outflow",
    cfNetCol: "Net",
    cf_operating: "Operating activities",
    cf_investing: "Investing activities",
    cf_financing: "Financing activities",
    cf_other_cash: "Transfers with cash outside this report",
    cf_unmapped: "Unmapped movements",
    cfSectionTotal: "Net cash from {x}",
    cfCash: "Cash and cash equivalents in this report: {x}",
    cfNoCash: "No treasury in this scope has an account, so there is no cash to report.",
    cfReconciled: "Reconciled: the net change equals the movement on the cash accounts in the ledger ({x}).",
    cfNotReconciled: "Not reconciled: the ledger moved the cash accounts by {l}, the statement shows {n} (difference {d}). An unbalanced migrated entry is the usual cause; open the cash accounts' statements.",
    cfUnmappedNote: "{n} counterpart accounts have no cash flow classification, so their movements are shown as unmapped instead of being guessed. Map their account types (or the accounts) in Cash flow classification.",
    cfMixedNote: "{n} entries move cash against accounts of more than one activity in opposite directions; each activity's share is shown as posted. Review them in the drill-down.",
    cfMappedBy_account: "account mapping",
    cfMappedBy_type: "account type mapping",
    cfDrill: "Entries",
    cfDrillTitle: "Entries behind: {x}",
    cfMapHint: "Classify each account type, and any account that differs from its type. Accounts linked to a treasury are the cash itself and are not classified. Nothing is classified until you choose it here.",
    cfMapType: "Account type",
    cfMapAccount: "Account",
    cfMapNone: "Not classified",
    cfMapSaved: "Cash flow classification saved.",
    cfMapAccounts: "Accounts that differ from their type",
    cfCashAccount: "cash",
    cfIndProposed: "PROPOSED definitions, not approved by an accountant: the legacy screens do not establish these indicators, so each one shows its formula, inputs and period. Ratios are rounded to 4 decimals; a zero denominator gives no value (\"Not defined\"), never zero or infinity.",
    cfIndProposedTag: "proposed, not accountant-approved",
    stReconciled: "Reconciled: the closing balance {c} equals the ledger balance at {at} ({l}), summed separately; difference {d}. Each ledger line appears once.",
    stNotReconciled: "Not reconciled: the closing balance {c} differs from the ledger balance at {at} ({l}) by {d}.",
    stLatest: "the latest posted entry",
    cfIndSource: "Source period: {from} to {to} ({b}). Cash figures come from the cash flow statement of the same period; liabilities as at the end date; revenues and profit from the period's posted entries.",
    cfIndUnmapped: "{n} counterpart accounts have no cash flow activity mapping ({x}): operating, investing and financing figures leave them out until they are classified.",
    cfIndValue: "Value",
    cfIndFormula: "Formula",
    cfIndInputs: "Inputs",
    cfIndZero: "Not defined: the denominator is zero",
    cfIndDays: "Days in the period: {n}",
    cfInd_operating_cash_flow: "Operating cash flow",
    cfIndF_operating_cash_flow: "Net cash from operating activities (cash flow statement)",
    cfInd_free_cash_flow: "Free cash flow",
    cfIndF_free_cash_flow: "Operating cash flow + net cash from investing activities",
    cfInd_net_cash_flow: "Net cash flow",
    cfIndF_net_cash_flow: "Closing cash − opening cash (all activities and transfers)",
    cfInd_cash_ratio: "Cash ratio",
    cfIndF_cash_ratio: "Closing cash ÷ liabilities (group 2) as at the end date",
    cfInd_operating_cash_flow_ratio: "Operating cash flow ratio",
    cfIndF_operating_cash_flow_ratio: "Operating cash flow ÷ liabilities (group 2) as at the end date",
    cfInd_cash_flow_margin: "Operating cash flow margin",
    cfIndF_cash_flow_margin: "Operating cash flow ÷ revenues (group 5, credit less debit) of the period",
    cfInd_cash_to_profit: "Cash conversion of profit",
    cfIndF_cash_to_profit: "Operating cash flow ÷ net profit (revenues less expenses) of the period",
    cfInd_days_cash_on_hand: "Days of cash on hand",
    cfIndF_days_cash_on_hand: "Closing cash ÷ (operating cash outflow ÷ days in the period)",
    custStatementTitle: "Customer and supplier statement",
    stDocument: "Document",
    stUnbranched: "{n} entries with no branch (manual or migrated) are left out by the branch filter.",
    bsPeriodFrom: "Current period from",
    bsPrior: "Results of earlier periods not closed",
    bsCurrent: "Current period result",
    bsEquation: "Assets {a} = Liabilities {l} + Equity {e} (including {r} of results not yet closed into equity); difference {d}",
    rpAllFilteredRows: "Every printed or exported figure covers all {n} rows of these filters."
  },
  ar: {
    impF_code: "كود الصنف", // new
    impF_nameAr: "الاسم بالعربية", // new
    impF_nameEn: "الاسم بالإنجليزية", // new
    impF_category: "التصنيف", // new
    impF_itemKind: "نوع الصنف", // new
    impF_taxType: "نوع الضريبة", // new
    impF_baseUnit: "الوحدة الأساسية", // new
    impF_baseBarcode: "باركود الوحدة الأساسية", // new
    impF_priceRetail: "سعر التجزئة", // new
    impF_priceWholesale: "سعر الجملة", // new
    impF_priceHalf: "سعر نصف الجملة", // new
    impF_unit2: "الوحدة الثانية", // new
    impF_unit2Pieces: "عدد قطع الوحدة الثانية", // new
    impF_unit2Barcode: "باركود الوحدة الثانية", // new
    impF_unit2PriceRetail: "سعر تجزئة الوحدة الثانية", // new
    impF_unit2PriceWholesale: "سعر جملة الوحدة الثانية", // new
    impF_unit2PriceHalf: "سعر نصف جملة الوحدة الثانية", // new
    impF_minQty: "الحد الأدنى للكمية", // new
    impF_discount: "الخصم %", // new
    impF_priceIncludeTax: "السعر شامل الضريبة (نعم/لا)", // new
    impF_quickList: "القائمة السريعة (نعم/لا)", // new
    impF_descriptionAr: "الوصف بالعربية", // new
    impF_descriptionEn: "الوصف بالإنجليزية", // new
    impTitle: "استيراد الأصناف", // new
    impSub: "أضف أصنافًا كثيرة دفعة واحدة من ملف Excel ‏(.xlsx) أو CSV.", // new
    impSheet: "الأصناف", // new
    impTemplate: "نزّل القالب", // new
    impTemplateHint: "صف لكل صنف: الوحدة الأساسية ووحدة ثانية اختيارية. التصنيف والنوع ونوع الضريبة والوحدات تُكتب بأسمائها كما في دلتا. الباركودات المتعددة في خلية واحدة يفصلها |. أعمدة الكود والباركود في قالب Excel منسّقة كنص فتبقى الأصفار البادئة.", // new
    impTemplateXlsx: "قالب Excel ‏(.xlsx)", // new
    impTemplateCsv: "قالب CSV", // new
    impChoose: "اختر الملف", // new
    impFileInfo: "{name}: {n} صفوف بيانات.", // new
    impReadFailed: "تعذّرت قراءة الملف. استخدم القالب محفوظًا بصيغة ‎.xlsx أو CSV ‏(UTF-8).", // new
    impMapping: "طابق الأعمدة", // new
    impField: "الحقل", // new
    impColumn: "العمود في الملف", // new
    impNotInFile: "غير موجود في الملف", // new
    impTextCol: "يبقى نصًا", // new
    impNoStock: "الاستيراد ينشئ الأصناف فقط: لا تُنشأ كميات أو تكلفة أو أرصدة حسابات. يُدخل مخزون أول المدة بمستند بضاعة أول المدة.", // new
    impMissing: "طابق الحقول المطلوبة: {x}.", // new
    impPreview: "افحص واعرض", // new
    impPreviewTitle: "المعاينة", // new
    impRows: "صفوف الملف", // new
    impValid: "صفوف جاهزة للاستيراد", // new
    impCreated: "الأصناف المنشأة", // new
    impErrorRows: "صفوف بها أخطاء", // new
    impRow: "الصف", // new
    impProblem: "المشكلة", // new
    impProblems: "المشكلات", // new
    impErrorFile: "نزّل ملف الأخطاء", // new
    impConfirm: "استورد {n} صنفًا", // new
    impSkipNote: "الصفوف التي بها أخطاء لا تُستورد. صحّحها في الملف واستورده مرة أخرى: الصفوف المستوردة سابقًا تظهر كموجودة ولا تُعدَّل.", // new
    impDone: "انتهى الاستيراد", // new
    impReplayed: "تم هذا الاستيراد من قبل: لم يُنشأ شيء مرة أخرى.", // new
    impPrevious: "استُورد هذا الملف من قبل ({at}، بواسطة {by}، {n} صنفًا).", // new
    impRules: "لا تُعدَّل الأصناف الموجودة: الكود أو الباركود المستخدم يظهر خطأً في صفه. الاستيراد لمن لديه صلاحية إضافة صنف فقط، وداخل منشأته.", // new
    impE_required: "مطلوب", // new
    impE_not_found: "غير موجود في دلتا", // new
    impE_invalid: "ليس رقمًا (اكتبه مثل 1234.50)", // new
    impE_duplicate_in_file: "مكرر في الملف (أول ظهور في الصف {row})", // new
    impE_exists: "مستخدم في صنف موجود", // new
    impE_yes_no: "اكتب نعم أو لا", // new
    impE_barcode_scientific: "باركود بصيغة علمية: حوّله Excel إلى رقم", // new
    impE_stored_as_number: "مخزّن كرقم في Excel وقد تضيع الأصفار البادئة. نسّق العمود كنص وأعد كتابته", // new
    printTestRetry: "أعد طباعة صفحة الاختبار", // new
    srClosePrint: "إقفال وطباعة التقرير", // new
    srPrintAgain: "اطبع مرة أخرى", // new
    srPrintAgainAsk: "لم تؤكد الطابعة الطباعة السابقة. افحص الورق أولًا: هل تطبع تقريرًا آخر؟", // new
    srPrintAgainYes: "نعم، اطبع مرة أخرى", // new
    itemMovement: "حركة الصنف", // new
    imOpening: "الرصيد الافتتاحي (كل الحركات السابقة)", // new
    imClosing: "الرصيد الختامي", // new
    imType: "الحركة", // new
    imIn: "وارد", // new
    imOut: "صادر", // new
    imBalance: "الرصيد", // new
    imType_opening: "بضاعة أول المدة", // new
    imType_purchase: "شراء", // new
    imType_sale: "بيع", // new
    imType_sale_return: "مرتجع مبيعات", // new
    imType_purchase_return: "مرتجع مشتريات", // new
    imType_transfer: "تحويل", // new
    imType_damaged: "تالف", // new
    imType_count: "تسوية جرد", // new
    imType_compromise: "تسوية", // new
    imReconciled: "مطابق: مجموع الحركات يساوي المخزون الحالي ({x}).", // new
    imNotReconciled: "غير مطابق: مجموع الحركات {l} والمخزون الحالي {h} (الفرق {d}).", // new
    imDraftsNote: "المستندات المرحّلة فقط تحرّك المخزون: المسودات لا تظهر. المستند المعكوس يظهر مع عكسه. الكميات بالوحدة الأساسية للصنف.", // new
    paySplit: "تقسيم", // new
    payRest: "الباقي", // new
    payFillRest: "ضع المبلغ غير المدفوع على هذه الطريقة", // new
    payCardNote: "تُسجَّل مدفوعات البطاقة والتحويل (مدى وغيرها) بطريقة الدفع فقط: دلتا غير متصلة بجهاز الشبكة. أتمّ الدفع على الجهاز أولًا.", // new
    invPostInvoice: "ترحيل الفاتورة", // new
    invSaveDraftHint: "يحفظ مسودة قابلة للتعديل دون أي أثر على المخزون أو النقد أو القيود أو التقارير.", // new
    invPostHint: "يحفظ ويرحّل: يُسجَّل المخزون والمدفوعات والقيد معًا مرة واحدة. الفاتورة المرحّلة لا تُعدَّل بل تُصحَّح.", // new
    invCorrect: "تصحيح", // new
    invCorrects: "تصحّح الفاتورة", // new
    invCorrectedBy: "صُحّحت بالفاتورة", // new
    invReplacementNote: "هذه المسودة تصحّح {x}. لم يتغير شيء بعد: تبقى {x} مرحّلة حتى ترحّل هذه المسودة وتؤكد. الترحيل يعكس {x} ويرحّل هذه الفاتورة في خطوة واحدة. حذف المسودة يُبقي {x} كما هي.", // new
    invCorrectedNote: "صُحّحت هذه الفاتورة: عُكست واستُبدلت بالفاتورة {x}، وتبقى محفوظة مع سجل التدقيق ومدفوعاتها.", // new
    invCorrectionPrepared: "أُعدّ تصحيح {x} كمسودة. لم يتغير شيء بعد: لا تُعكس {x} إلا عند ترحيل تلك المسودة.", // new
    invCorrectionOf: "تصحيح {x}", // new
    invCorrectedOk: "أُعدّت المسودة البديلة. تبقى {x} دون تغيير حتى ترحّل البديلة.", // new
    invCorrectSub: "تُعدّ مسودة بديلة بنفس البنود وبالتاريخ أدناه، ولا يتغير شيء الآن. ترحيل البديلة (بعد التأكيد) يعكس هذه الفاتورة بذلك التاريخ ويرحّل البديلة في خطوة واحدة. المدفوعات السابقة تبقى وتستخدمها البديلة: لا تُرد ولا تُحصّل مرة أخرى. حذف المسودة يلغي التصحيح.", // new
    invCorrectGo: "أعدّ البديلة", // new
    invCarriedHint: "المدفوع على {x} وقدره {p} محفوظ: تستخدم هذه الفاتورة منه {c}. أضف دفعة فقط لما يزيد على ذلك.", // new
    invCarriedShow: "{c} من مدفوعات {x} (محفوظة، لم تُرد ولم تُحصّل مرة أخرى).", // new
    invConfirmTitle: "ترحيل تصحيح {x}", // new
    invConfirmSub: "في خطوة واحدة: تُعكس {x} بتاريخ {d} (يعود مخزونها وقيدها، وتبقى مدفوعاتها)، وتُرحّل هذه الفاتورة. إذا فشل أي جزء لا يتغير شيء.", // new
    invConfirmOriginal: "{x} (معكوسة)", // new
    invConfirmReplacement: "هذه الفاتورة", // new
    invConfirmCarried: "مدفوعات {x} المستخدمة", // new
    invConfirmNew: "مدفوعات جديدة", // new
    invConfirmOnAccount: "المتبقي على الحساب", // new
    invConfirmCredit: "رصيد دائن على الحساب (مدفوع على الأصلية بأكثر من هذا الإجمالي)", // new
    invConfirmGo: "اعكس ورحّل", // new
    fieldCorrectionNeedsParty: "الفاتورة الأصلية مدفوعة: اختر العميل أو المورد الذي يُحفظ له المبلغ.", // new
    posCompleteSale: "إتمام البيع", // new
    posCompleteNote: "إتمام البيع يرحّل البيع بهذه المدفوعات في هذه الوردية في خطوة واحدة، ولا يُسجَّل شيء قبله. للاحتفاظ بالسلة دون تسجيل أي شيء أغلق هذه النافذة واحفظها كمسودة.", // new
    posSaveDraftHint: "يحتفظ بالسلة كمسودة: لا تُسجَّل مدفوعات ولا مخزون ولا نقد ولا أرقام وردية حتى تتم البيع.", // new
    posDraftSaved: "حُفظت المسودة ({total}). لا يُسجَّل شيء حتى تتمها.", // new
    posDrafts: "المسودات", // new
    posDraftsNote: "سلال محفوظة. المسودة لا تسجّل شيئاً: لا مدفوعات ولا مخزون ولا نقد ولا قيود ولا أرقام وردية. استأنف مسودة لإتمامها.", // new
    posNoDrafts: "لا توجد مسودات محفوظة.", // new
    posDraftResume: "استئناف", // new
    posDraftEditing: "هذه السلة تكمل مسودة محفوظة. «إتمام البيع» يرحّلها و«حفظ كمسودة» يحتفظ بها.", // new
    posDraftCartBusy: "احفظ السلة الحالية أو أفرغها قبل استئناف مسودة.", // new
    rpPrint: "طباعة", // new
    rpPrintBrowser: "طباعة أو حفظ PDF", // new
    rpPrintOn: "الطباعة على {printer}", // new
    rpPrintPage: "صفحة {i} من {n}", // new
    rpPrintContinued: "تابع", // new
    rpPrintBy: "طبعه {u} في {d}", // new
    rpPrintNoRows: "لا توجد صفوف لهذه المرشحات.", // new
    rpPrintSent: "أُرسل إلى {printer}.", // new
    rpPrintFailed: "لم يُطبع على طابعة A4 في هذا الجهاز: {x}. لم يُطبع شيء؛ يمكنك المحاولة مرة أخرى أو استخدام الطباعة أو حفظ PDF.", // new
    rpPrintUnknown: "لم تؤكد الطابعة طباعة التقرير ({x}). افحص الطابعة قبل إعادة الطباعة حتى لا يُطبع مرتين.", // new
    rpPrinting: "جارٍ الإرسال إلى الطابعة…", // new
    rpPeriod: "الفترة", // new
    rpBranch: "الفرع", // new
    rpAllBranches: "كل الفروع", // new
    cashFlow: "قائمة التدفقات النقدية", // new
    cashFlowIndicators: "مؤشرات التدفقات النقدية", // new
    cashFlowMappings: "تصنيف التدفقات النقدية", // new
    cfOpening: "النقد وما في حكمه أول الفترة", // new
    cfClosing: "النقد وما في حكمه آخر الفترة", // new
    cfNet: "صافي التغير في النقد", // new
    cfInflow: "داخل", // new
    cfOutflow: "خارج", // new
    cfNetCol: "الصافي", // new
    cf_operating: "الأنشطة التشغيلية", // new
    cf_investing: "الأنشطة الاستثمارية", // new
    cf_financing: "الأنشطة التمويلية", // new
    cf_other_cash: "تحويلات مع نقد خارج هذا التقرير", // new
    cf_unmapped: "حركات غير مصنفة", // new
    cfSectionTotal: "صافي النقد من {x}", // new
    cfCash: "النقد وما في حكمه في هذا التقرير: {x}", // new
    cfNoCash: "لا توجد خزينة لها حساب في هذا النطاق، فلا يوجد نقد لعرضه.", // new
    cfReconciled: "مطابق: صافي التغير يساوي حركة حسابات النقد في دفتر الأستاذ ({x}).", // new
    cfNotReconciled: "غير مطابق: حركة حسابات النقد في الدفتر {l} والقائمة تعرض {n} (الفرق {d}). السبب المعتاد قيد مرحّل غير متوازن؛ افتح كشوف حسابات النقد.", // new
    cfUnmappedNote: "{n} حسابات مقابلة بلا تصنيف للتدفقات النقدية، فتظهر حركاتها غير مصنفة بدل تخمينها. صنّف أنواع حساباتها (أو الحسابات) في تصنيف التدفقات النقدية.", // new
    cfMixedNote: "{n} قيود تحرك النقد مقابل حسابات من أكثر من نشاط باتجاهين متعاكسين؛ تظهر حصة كل نشاط كما رُحّلت. راجعها في التفاصيل.", // new
    cfMappedBy_account: "تصنيف الحساب", // new
    cfMappedBy_type: "تصنيف نوع الحساب", // new
    cfDrill: "القيود", // new
    cfDrillTitle: "القيود الخاصة بـ: {x}", // new
    cfMapHint: "صنّف كل نوع حساب، وأي حساب يختلف عن نوعه. الحسابات المرتبطة بخزينة هي النقد نفسه ولا تُصنف. لا يُصنف شيء حتى تختاره هنا.", // new
    cfMapType: "نوع الحساب", // new
    cfMapAccount: "الحساب", // new
    cfMapNone: "غير مصنف", // new
    cfMapSaved: "حُفظ تصنيف التدفقات النقدية.", // new
    cfMapAccounts: "حسابات تختلف عن نوعها", // new
    cfCashAccount: "نقد", // new
    cfIndProposed: "تعريفات مقترحة لم يعتمدها محاسب: لا تحدد شاشات النظام القديم هذه المؤشرات، لذا يعرض كل مؤشر صيغته ومدخلاته وفترته. تُقرّب النسب إلى 4 خانات؛ والمقام الصفري لا يعطي قيمة («غير معرّف») وليس صفراً أو ما لا نهاية.", // new
    cfIndProposedTag: "مقترحة، غير معتمدة من محاسب", // new
    stReconciled: "مطابق: الرصيد الختامي {c} يساوي رصيد الدفتر في {at} ({l}) محسوباً بشكل مستقل؛ الفرق {d}. يظهر كل سطر قيد مرة واحدة.", // new
    stNotReconciled: "غير مطابق: الرصيد الختامي {c} يختلف عن رصيد الدفتر في {at} ({l}) بمقدار {d}.", // new
    stLatest: "آخر قيد مرحّل", // new
    cfIndSource: "فترة المصدر: من {from} إلى {to} ({b}). أرقام النقد من قائمة التدفقات النقدية للفترة نفسها، والخصوم كما في تاريخ النهاية، والإيرادات والأرباح من قيود الفترة المرحّلة.", // new
    cfIndUnmapped: "{n} من الحسابات المقابلة بلا تصنيف نشاط في التدفقات النقدية ({x}): تُستبعد من أرقام التشغيل والاستثمار والتمويل حتى تُصنَّف.", // new
    cfIndValue: "القيمة", // new
    cfIndFormula: "الصيغة", // new
    cfIndInputs: "المدخلات", // new
    cfIndZero: "غير معرّف: المقام صفر", // new
    cfIndDays: "أيام الفترة: {n}", // new
    cfInd_operating_cash_flow: "التدفق النقدي التشغيلي", // new
    cfIndF_operating_cash_flow: "صافي النقد من الأنشطة التشغيلية (قائمة التدفقات النقدية)", // new
    cfInd_free_cash_flow: "التدفق النقدي الحر", // new
    cfIndF_free_cash_flow: "التدفق النقدي التشغيلي + صافي النقد من الأنشطة الاستثمارية", // new
    cfInd_net_cash_flow: "صافي التدفق النقدي", // new
    cfIndF_net_cash_flow: "نقد آخر الفترة − نقد أول الفترة (كل الأنشطة والتحويلات)", // new
    cfInd_cash_ratio: "نسبة النقدية", // new
    cfIndF_cash_ratio: "نقد آخر الفترة ÷ الخصوم (المجموعة 2) في تاريخ النهاية", // new
    cfInd_operating_cash_flow_ratio: "نسبة التدفق النقدي التشغيلي", // new
    cfIndF_operating_cash_flow_ratio: "التدفق النقدي التشغيلي ÷ الخصوم (المجموعة 2) في تاريخ النهاية", // new
    cfInd_cash_flow_margin: "هامش التدفق النقدي التشغيلي", // new
    cfIndF_cash_flow_margin: "التدفق النقدي التشغيلي ÷ إيرادات الفترة (المجموعة 5، الدائن ناقص المدين)", // new
    cfInd_cash_to_profit: "تحويل الربح إلى نقد", // new
    cfIndF_cash_to_profit: "التدفق النقدي التشغيلي ÷ صافي ربح الفترة (الإيرادات ناقص المصروفات)", // new
    cfInd_days_cash_on_hand: "أيام تغطية النقد", // new
    cfIndF_days_cash_on_hand: "نقد آخر الفترة ÷ (المدفوعات النقدية التشغيلية ÷ أيام الفترة)", // new
    custStatementTitle: "كشف حساب عميل أو مورد", // new
    stDocument: "المستند", // new
    stUnbranched: "{n} قيود بلا فرع (يدوية أو مرحّلة) لا يشملها مرشح الفرع.", // new
    bsPeriodFrom: "الفترة الحالية من", // new
    bsPrior: "نتائج فترات سابقة لم تُقفل", // new
    bsCurrent: "نتيجة الفترة الحالية", // new
    bsEquation: "الأصول {a} = الخصوم {l} + حقوق الملكية {e} (منها {r} نتائج لم تُقفل في حقوق الملكية)؛ الفرق {d}", // new
    rpAllFilteredRows: "كل رقم مطبوع أو مصدّر يشمل جميع الصفوف ({n}) لهذه المرشحات." // new
  }
};
